import { ButtonLarge } from 'src/components/ButtonLarge'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'

export const ContainerFlex = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Title = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h8};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const Info = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-size: ${theme.typograph.fontsize.h5};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const RegistrationContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    gap: 2rem;
  `
)

export const RegistrationLabel = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h4};
      line-height: ${theme.layout.lineHeight.big};
      color: ${theme.colors.primary.main70};
      margin-bottom: ${theme.layout.margin.medium};
    }
  `
)

export const RegistrationNumber = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h10};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.primary.main};
    }
  `
)

export const ContainerImage = styled('div')(
  ({ theme }) => css`
    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 80%;
    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const ButtonLargeCuston = styled(ButtonLarge)(
  ({ theme }) => css`
    && {
      width: 100%;
      padding: ${theme.layout.padding.medium};
    }
  `
)
export const ContainerButton = styled('div')(
  ({ theme }) => css`
    && {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.gap.medium};
    }
  `
)
